import * as _ from 'lodash'
import {FundTypeBO} from "./FundTypeBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";


export class FundTypeBOValidations {

    static ValidateEmptyFields(aBO: FundTypeBO): Promise<void> {

        return new Promise<void>((resolve, error) => {

            // Valid Fund Type ID
            if (_.isEmpty(aBO.WB_FundType.cif.FUNDTYPE_ID) || _.isNull(aBO.WB_FundType.cif.FUNDTYPE_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyId',
                        type: MessageType.Error,
                        title: "Fund Type ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyId')
            }

            if (_.isEmpty(aBO.WB_FundType.cif.FUNDTYPE_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyName',
                        type: MessageType.Error,
                        title: "Fund Type Name cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyName')
            }

            if (_.isEmpty(aBO.WB_FundType.cif.SOURCE_ID) || _.isNull(aBO.WB_FundType.cif.SOURCE_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'sourceid',
                        type: MessageType.Error,
                        title: "Source ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('sourceid')
            }



            resolve()
        })
    }
}

